import type { I18nFn } from 'i18n/types/I18nFn';

export function getCmsTotalReactionsText(i18n: I18nFn, totalReactions: number) {
  if (totalReactions === 0) {
    return i18n('Be the first to like this post');
  }

  if (totalReactions === 1) {
    return i18n('%(totalReactions)s person reacted', {
      totalReactions,
    });
  }

  if (totalReactions > 1) {
    return i18n('%(totalReactions)s people reacted', {
      totalReactions,
    });
  }
}
